import { Component, h, Host, Prop } from '@stencil/core';
import CloseIcon from '../svg-elements/close-icon';

@Component({
  tag: 'rtr-close-button',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrCloseButton {
  @Prop() onClose: () => void;
  @Prop() hideOnLaptop: boolean;
  @Prop() hideBelowLaptop: boolean;

  render() {
    return (
      <Host class={{ GlobalButtonSVG: true, RtrCBHideLaptop: this.hideOnLaptop, RtrCBHideBelowLaptop: this.hideBelowLaptop }} onClick={this.onClose} tabindex="0">
        <CloseIcon />
      </Host>
    );
  }
}
